import { createStyles } from "@material-ui/core";
import { getTheme } from "../../Themes";

const theme = getTheme();

export default createStyles({
  containerDivText: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px',

    color: theme.palette.text.primary,
  },
  closeButton: {
    position: 'absolute',
    right: '8px',
    top: '0px',
    color: theme.palette.text.primary,
  },
  contentTableRow: {
    borderBottom: '1px solid rgba(81, 81, 81, 1) !important',
    borderCollapse: 'unset',
    borderRadius: '5px',
    marginBottom: '1px',
  },
  datePicker: {
    display: 'flex',
    alignItems: 'flex-end',
    fontStyle: 'italic',

    color: '#C4C4C4',
    fontFamily: 'sans-serif',
    marginBottom: '6px',
  },
  datePickerLabel: {
    fontWeight: 300,
  },
  datePickerInput: {
    '& label + .MuiInput-formControl': {
      marginTop: '7px',
    },
  },
  datePickerInputStart: {
    borderBottom: 'outset',
    borderBottomWidth: '1px',
    marginRight: '10px',
  },
  datePickerInputLeft: {
    marginLeft: '10px',
    borderBottom: 'outset',
    borderBottomWidth: '1px',
  },
  detailsIcon: {
    transform: 'rotate(0.5turn) rotateX(45deg)',
    display: 'block',
    margin: '0 auto',
  },
  openLinkIcon: {
    display: 'block',
    margin: '0 auto',
  },
  iconButton: {
    padding: 10,
  },
  iconStyle: {},
  inputSearch: {
    flex: 1,
    '&:before': {
      border: 'none',
    },
  },
  inputLabelPropsStyle: {
    top: '-10px',

    fontWeight: 300,
  },
  inputPropsStyle: {
    height: '26px',
    padding: '0 31px',

    fontWeight: 300,
  },
  inputStyles: {
    fontWeight: 300,
  },
  paperOverflow: {
    maxHeight: '81vh',
    overflow: 'auto',
  },
  reduceSvgIconSize: {
    '& svg': {
      transform: 'scale(0.7)',
    },
  },
  rootSearch: {
    padding: '2px 0',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    '& .MuiInput-root:before': {
      border: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: 'none',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
    },
  },
  statusValidated: {
    float: 'right',
    color: theme.palette.primary.main,
  },
  statusDraft: {
    float: 'right',
    color: theme.palette.secondary.main,
  },
  tableContainer: {
    padding: '10px',
    overflow: 'hidden',
    paddingTop: 0,
  },
  textStyle: {
    color: '#C4C4C4',

    fontWeight: 200,
  },
  videoPlayer: {
    maxWidth: '100%',
    marginTop: '20px',
    maxHeight: '360px',
    margin: '0 auto',
    display: 'block',
    objectFit: 'cover',
  },
  audioPlayer: {
    maxWidth: '100%',
    margin: '0 auto',
    display: 'block',
  },
  cellS: {
    padding: '0px',
    display: 'flex',
    width: '12%',
    alignItems: 'center',
    fontWeight: 400,
    fontFamily: 'Lato',
    fontStyle: 'normal',
  },
  buttonDense: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    height: '100%',
  },
  scrollSpotList: {
    overflow: 'auto',
    height: '415px',
    width: '95%',
  },
  dialogContent: {
    padding: theme.spacing(2),
    width: '220px',
  },
  secondaryColor: {
    color: theme.palette.text.secondary,
  },
  muiDialogTitle: {
    cursor: 'move',
    textAlign: 'center',
    color: theme.palette.primary.main,
    padding: theme.spacing(2),
  },
});